import { UserDto } from "./user.dto";
import { ChatDto } from "./chat.dto";
import { FileUploadDto } from "./file.dto";
import { MessageAttachmentTypesEnum } from "../../enums/message-attachment-types.enum";
import { MessageMetadata } from "../../interfaces/chats";
import { SystemMessageTypesEnum } from "../../enums/system-message-types.enum";
import { ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { Base64AllowedMimeTypes, MaxBase64FileSize } from "../../decorators";
import {
	ALLOWED_CHAT_MESSAGE_PICTURE_MIME_TYPES,
	ALLOWED_CHAT_MESSAGE_VIDEO_MIME_TYPES,
} from "../../constants";
import { ReactionTypeDto } from "./reaction.dto";
import { MentionedUserToMessageDto, NewMentionedUserToMessageDto } from "./mentioned-user-to-message.dto";

export class MessageDto {
	public id: string;
	public message: string;
	public userId: string | null; // userId = NULL, if user is deleted
	public chatId: string;
	public metadata: MessageMetadata | null;
	public isSystemMessage: boolean;
	public systemMessageTypeId: SystemMessageTypesEnum | null;
	public attachmentEntityId: string | null;
	public attachmentTypeId: MessageAttachmentTypesEnum | null;
	public isEveryoneMentioned: boolean;
	public createdAt: Date;
	public updatedAt: Date;
	public user?: UserDto | null;
	public chat?: ChatDto;
	public reactionTypes?: ReactionTypeDto[];
	public mentionedUsers?: MentionedUserToMessageDto[];
}

export class NewMessageDto {
	public message: string;
	public attachmentEntityId?: string | null;
	public attachmentTypeId?: MessageAttachmentTypesEnum | null;
	public isEveryoneMentioned?: boolean;
	public mentionedUsers?: NewMentionedUserToMessageDto[];

	public event?: { id: string, instance: Date }

	@ValidateNested()
	@Type(() => FileUploadDto)
	@MaxBase64FileSize(20)
	@Base64AllowedMimeTypes(ALLOWED_CHAT_MESSAGE_PICTURE_MIME_TYPES)
	public picture?: FileUploadDto;

	@ValidateNested()
	@Type(() => FileUploadDto)
	@MaxBase64FileSize(100)
	@Base64AllowedMimeTypes(ALLOWED_CHAT_MESSAGE_VIDEO_MIME_TYPES)
	public video?: FileUploadDto;
}

export class NewMessageToUsersDto {
	public message: NewMessageDto;
	public targetUserIds: string[];
}

export class NewSystemMessageDto<T extends SystemMessageTypesEnum> implements Pick<MessageDto, 'chatId'> {
	public message?: string;
	public chatId: string;
	public userId?: string;
	public metadata: MessageMetadata<T>;
	public systemMessageTypeId: T;
}
